import React from 'react';

import {MyAppointmentDetails} from 'presentation/modules/myAppointments/ui/pages/MyAppointmentDetails';
import {FlowTypeEnumWithoutAuth} from 'presentation/utils';

export const MakeMyAppointmentsDetails: React.FC<{
	flowType: FlowTypeEnumWithoutAuth;
}> = ({flowType}) => {
	return <MyAppointmentDetails flowType={flowType} />;
};
